var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 51,
    viewBox: "0 0 41 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.043 50.241C14.2305 48.7916 9.44526 45.468 5.66214 40.2702C1.87903 35.0973 0 29.3247 0 23.0023V7.75861L20.043 0.261719L40.086 7.75861V23.0023C40.086 29.3247 38.2069 35.0973 34.4238 40.2702C30.6407 45.443 25.8554 48.7666 20.043 50.241ZM20.043 44.9932C24.1017 43.7437 27.4839 41.2697 30.1897 37.5963C32.8955 33.9228 34.499 29.7995 34.95 25.2514H20.043V5.58452L5.01075 11.2072V24.1518C5.01075 24.4517 5.06085 24.8265 5.13601 25.2764H20.043V45.0182V44.9932Z",
    fill: "#142862"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityIcon);
export default __webpack_public_path__ + "static/media/security_icon.7909bbb935e00a43e13aa92b76f7afd1.svg";
export { ForwardRef as ReactComponent };